import React from 'react'

function ForestArmyContent() {
  return (
    <>
    <div className="w-screen text-center bg-gray-50">
      <div className="container mx-auto flex flex-col lg:flex-row items-center">
        
      <div className="lg:w-1/2 px-4">
  <h2 className="text-3xl md:text-3xl font-bold mb-4 text-blue-700">Pahad Green Army</h2>
  <p className="text-lg md:text-lg lg:text-lg font-serif">
    Welcome to Pahad Green Army, where we're dedicated to planting 20,000 trees in our local area. By joining our team, you contribute directly to improving air quality, creating wildlife habitats, and enhancing community beauty. Whether you're a seasoned environmentalist or new to eco-friendly initiatives, there's a place for you. Our commitment to transparency ensures every tree planted is part of a carefully planned effort for long-term sustainability. 

    Joining Pahad Green Army is simple – take membership and participate in our tree planting events. Together, we'll realize our vision of a greener, healthier future. Every tree counts, and your involvement makes a significant impact. Together, we can inspire others and leave a legacy of environmental stewardship. 

    Take the first step towards making a meaningful impact. Take membership now and be part of Pahad Green Army’s mission to create a sustainable environment for generations to come.
  </p>
  <p className="text-lg md:text-lg lg:text-lg font-serif text-blue-600 mt-5">
  Take membership today and become a part of something bigger!<br/>
  </p>
</div>


        
        <div className="lg:w-1/2 px-4 hidden lg:block md:block">
          <img src="/logoicon.png" alt="Our logo" className="mx-auto" />
        </div>
      </div>
    </div>
    </>
  )
}

export default ForestArmyContent